export abstract class PointsCalc {
    public static CalculatePlaces(entryCount: number, entryScaleMultiple: number, placesAwardedPerEntryScale: number): number
    {
        return Math.ceil(entryCount / entryScaleMultiple) * placesAwardedPerEntryScale;
    }
    public static CalculatePoints(pointsBase: number, entryCount: number, entryScaleMultiple: number, pointsAwardedPerEntryScale: number): number
    {
        return pointsBase + (Math.ceil(entryCount / entryScaleMultiple) - 1)  * pointsAwardedPerEntryScale;
    }
}


// WEBPACK FOOTER //
// ./src/lib/points/PointsCalc.ts